module.exports = __webpack_public_path__ + "static/media/(DH)-_MG_5274_-_bijuterias.770fff85.jpg";